
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import BenefitsBadges from "./BenefitsBadges";

interface HeroSectionProps {
  benefits: string[];
}

const HeroSection = ({ benefits }: HeroSectionProps) => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="text-center mb-20"
    >
      <div className="mb-8">
        <motion.div
          initial={{ scale: 0.9 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex items-center justify-center gap-3 mb-6"
        >
          <h1 className="text-6xl md:text-8xl font-bold text-foreground tracking-tight">
            doozy
          </h1>
        </motion.div>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="text-2xl md:text-3xl text-muted-foreground mb-2"
        >
          make it easy, digital solutions
        </motion.p>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="text-lg text-foreground font-semibold"
        >
          by bytehype
        </motion.p>
      </div>
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
        className="max-w-3xl mx-auto mb-12"
      >
        <p className="text-xl text-muted-foreground leading-relaxed mb-8">
          The complete digital toolkit for modern businesses. Create websites, design graphics, 
          generate content, and automate workflows - all powered by AI.
        </p>
        
        <BenefitsBadges benefits={benefits} />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.2 }}
        className="flex flex-col sm:flex-row gap-4 justify-center items-center"
      >
        <Button 
          size="lg" 
          className="px-8 py-6 text-lg bg-primary hover:bg-primary/90 shadow-lg hover:shadow-xl transition-all"
          onClick={() => navigate('/pricing')}
        >
          Start Free Trial
          <ArrowRight className="ml-2 h-5 w-5" />
        </Button>
        <Button 
          variant="outline" 
          size="lg" 
          className="px-8 py-6 text-lg"
          onClick={() => navigate('/tools')}
        >
          Explore Tools
        </Button>
      </motion.div>
    </motion.div>
  );
};

export default HeroSection;
